import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Select, Space, Tag } from "antd";
import UserSelectOption from "common/components/userSelect/userSelect";
import { useRef, useState } from "react";
import K from "utilities/constants";
import { customUserHandleSearch } from "utilities/generalUtility";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import labelStyles from "../candidateFieldLabel/candidateFieldLabel.module.scss";

const { Option } = Select;

export const CandidateRecruitersField = ({
  label,
  recruiters,
  availableRecruiters = [],
  isEditable = false,
  disabled = false,
  onEdit,
  required = false,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const inputRef = useRef(recruiters.map((r) => r.id));

  const handleSave = () => {
    if (required && (!inputRef.current || inputRef.current.length === 0)) {
      setValidationError("This field is required.");
      return;
    }
    setValidationError(null);
    onEdit?.(inputRef.current);
    setIsEdit(false);
  };

  const handleCancel = () => {
    inputRef.current = recruiters.map((r) => r.id);
    setValidationError(null);
    setIsEdit(false);
  };

  if (isEdit) {
    return (
      <div>
        <CandidateFieldLabel required={required}>{label}</CandidateFieldLabel>
        <Select
          placeholder="Select Recruiters"
          showArrow
          allowClear
          optionLabelProp="title"
          showSearch
          mode="multiple"
          filterOption={customUserHandleSearch}
          defaultValue={inputRef.current}
          onChange={(val) => {
            inputRef.current = val;
          }}
          style={{ width: "100%" }}
          status={validationError ? "error" : undefined}
        >
          {availableRecruiters.map(({ recruiter }) => (
            <Option
              key={recruiter.id}
              value={recruiter.id}
              title={recruiter.name}
            >
              <UserSelectOption
                userEmail={recruiter.email}
                clients={recruiter.clients}
              >
                {recruiter.name}
              </UserSelectOption>
            </Option>
          ))}
        </Select>
        {validationError && (
          <div className={labelStyles.errorMessage}>{validationError}</div>
        )}
        <div style={{ marginTop: 4 }}>
          <Button
            type="link"
            onClick={handleCancel}
            icon={<CloseCircleOutlined className="closeIcon" />}
          />
          <Button
            type="link"
            onClick={handleSave}
            icon={<CheckCircleOutlined className="checkIcon" />}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      <Space size={4} style={{ minHeight: 24 }}>
        <div>
          {recruiters.length
            ? recruiters.map(({ id, name }) => <Tag key={id}>{name}</Tag>)
            : K.NullPlaceholder}
        </div>
        {isEditable && !disabled && (
          <Button
            style={{ width: 16, height: 16 }}
            type="link"
            onClick={() => {
              inputRef.current = recruiters.map((r) => r.id);
              setIsEdit(true);
            }}
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </div>
  );
};
